import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { RestfulService } from 'src-ironside/services/restful.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

export type Department = {
    id: string;
    title: string;
    value: string;
};

@Injectable()
export class DepartmentRepository extends RestfulService {
    constructor(public override httpClient: HttpClient, public override router: Router) {
        super(httpClient, router);
    }
    find(): Observable<Department[]> {
        return this.doGet(`parametre/nomtable/DEPARTMENT`).pipe(
            map((res) =>
                res
                    .map((department: any) => ({
                        id: department.id,
                        title: department.mapLocalLibelle,
                        value: department.valeur,
                    }))
                    .sort((a: Department, b: Department) => a.value.localeCompare(b.value))
            )
        );
    }
}
